import { LeafIcon } from "@/app/components/system/Icons";

/** Circular brand mark — moss circle with a leaf icon. */
export function PlantitaMark({ size = 36 }: Readonly<{ size?: number }>) {
  const iconSize = Math.round(size * 0.5);
  return (
    <span
      className="inline-grid place-items-center rounded-full bg-moss text-paper shrink-0"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <LeafIcon size={iconSize} stroke={2} />
    </span>
  );
}
